import { companyDetailsTranslations } from '../translation'

export function getCompanyContractType(partnerType: string) {
  switch (true) {
    case partnerType.toLowerCase().includes('power') ||
      partnerType.toLowerCase().includes('synergy'):
      return companyDetailsTranslations.details.hpMemberUnderAmplifySince
    case partnerType.toLowerCase() === 'business partner':
      return companyDetailsTranslations.details.hpMemberUnderBusinessSince
    case partnerType.toLowerCase().includes('distributor'):
      return companyDetailsTranslations.details.hpMemberUnderDistributorSince
    default:
      return ''
  }
}
